import {
    httpStoreProjectOtherPathologies,
    HttpStoreProjectOtherPathologiesOptions
} from '@/features/projects/http/projects.http'
import {QUERY_KEYS, queryClient} from '@/queryClient'
import {ErrorResponseData} from '@/types'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

// Use temporary interface until the actual HTTP functions are properly implemented
interface UseStoreProjectOtherPathologies {
    urlParams: HttpStoreProjectOtherPathologiesOptions['urlParams']
    options?: UseMutationOptions<
        unknown,
        AxiosError<ErrorResponseData>,
        HttpStoreProjectOtherPathologiesOptions['payload']
    >
}

export const useStoreProjectOtherPathologies = ({urlParams, options}: UseStoreProjectOtherPathologies) => {
    return useMutation({
        ...options,
        mutationFn: payload => httpStoreProjectOtherPathologies({urlParams, payload}),
        // Refetch the project so the header progressStatus (backend-computed) reflects this change.
        onSuccess: (data, variables, context) => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECT, urlParams.projectId]})
            options?.onSuccess?.(data, variables, context)
        }
    })
}
